import { useState } from "react";
import { IInspectionTypeScheduleCalendar } from "../components/InspectionTypeScheduleCalendar";
import { CalendarDate, today, getLocalTimeZone, parseDate } from "@internationalized/date";

interface IUseInspectionTypeScheduleCalendar {
  inspectionId?: string;
  inspectionTypeId: string;
  onSelect?: (inspectorId: string, date: string, meridien: "AM" | "PM") => void;
}
export default function useInspectionTypeScheduleCalendar({
  inspectionId,
  inspectionTypeId,
  onSelect = () => {},
}: IUseInspectionTypeScheduleCalendar): IInspectionTypeScheduleCalendar {
  const [currentWeek, setCurrentWeek] = useState<CalendarDate>(today(getLocalTimeZone()));

  const [selectedInspectorId, setSelectedInspectorId] = useState<string | null>(null);
  const [selectedDate, setSelectedDate] = useState<CalendarDate | null>(null);
  const [selectedMeridiem, setSelectedMeridiem] = useState<"AM" | "PM" | null>(null);

  const handleNextWeekChange = () => {
    setCurrentWeek(currentWeek.add({ weeks: 1 }));
  };

  const handlePrevWeekChange = () => {
    setCurrentWeek(currentWeek.subtract({ weeks: 1 }));
  };

  const _onSelect = (inspectorId: string, date: string, meridiem: "AM" | "PM") => {
    const updatedSelectedDate = parseDate(date);
    // Flip to the week of the selected date on the calendar
    setCurrentWeek(updatedSelectedDate);

    // Set current inspector, meridiem, and date fields
    setSelectedDate(updatedSelectedDate);
    setSelectedInspectorId(inspectorId);
    setSelectedMeridiem(meridiem);

    // Call custom onSelect callback function
    onSelect(inspectorId, date, meridiem);
  };

  return {
    inspectionTypeId: inspectionTypeId,
    inspectionId: inspectionId,
    onNextWeekClick: handleNextWeekChange,
    onPrevWeekClick: handlePrevWeekChange,
    currentWeek: currentWeek,
    selectedDate: selectedDate,
    selectedMeridiem: selectedMeridiem,
    selectedInspectorId: selectedInspectorId,
    setSelectedDate: setSelectedDate,
    setSelectedInspectorId: setSelectedInspectorId,
    setCurrentWeek: setCurrentWeek,
    setSelectedMeridiem: setSelectedMeridiem,
    onSelect: _onSelect,
  };
}
